export default "__VITE_ASSET__a3c005d0__"